import FusionCharts from 'fusioncharts'
import charts from 'fusioncharts/fusioncharts.charts'
import ReactFusioncharts from 'react-fusioncharts'
import React from 'react'
import { DoughnutChartProps } from './DoughnutChart.types'
import { statsColorPallette } from 'store'
import styles from './DoughnutChart.module.scss'

// Resolves charts dependency
charts(FusionCharts)

const DoughnutComponent = (props: DoughnutChartProps) => {
  const dataSource = {
    chart: {
      // caption: 'Split of Revenue by Product Categories',
      // subCaption: 'Last year',
      // numberPrefix: '$',
      defaultCenterLabel: props.centerLabel,
      centerLabelColor: styles.secondaryContent,
      centerLabelFontSize: '15',
      centerLabelFontFamily: 'Open Sans, sans-serif',
      // centerLabel: 'Revenue from $label: $value',
      decimals: '0',
      theme: 'fusion',
      showLegend: 0,
      showLabels: 0,
      showValues: 0,
      // bgColor: 'transparent',
      bgAlpha: 0,
      showBorder: 0,
      paletteColors: statsColorPallette.map(({ fill }) => fill).join(', '),
      // paletteColors: '#3AABF2, #254291, #70D6C6, #2985AE, #B021D9, #2D65FF',
      use3DLighting: 0,
      doughnutRadius: '65%'
    },
    data: [{ label: 'label', value: '5' }]
  }
  dataSource.data = props.data ?? dataSource.data

  return (
    <ReactFusioncharts
      type='doughnut2d'
      width='100%'
      height='40%'
      backgroundColor='#CCCCCC'
      dataFormat='JSON'
      dataSource={dataSource}
      containerBackgroundColor='transparent'
    />
  )
}

const Doughnut = DoughnutComponent
export { Doughnut }
